<template>
  <div class="category-list">
    <div class="list-header">
      <h2>分类管理</h2>
      <el-button type="primary" @click="showAddModal = true">新增分类</el-button>
    </div>
    <el-table :data="categories" border>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="name" label="分类名称"></el-table-column>
      <el-table-column prop="articleCount" label="文章数量"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="editCategory(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteCategory(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="新增/编辑分类" :visible.sync="showAddModal">
      <el-form :model="categoryForm" label-width="80px">
        <el-form-item label="分类名称">
          <el-input v-model="categoryForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAddModal = false">取消</el-button>
        <el-button type="primary" @click="saveCategory">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCategories, saveCategory, deleteCategory } from '@/api/blog'

export default {
  name: 'CategoryList',
  data() {
    return {
      categories: [],
      showAddModal: false,
      categoryForm: {
        id: null,
        name: ''
      }
    }
  },
  mounted() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      const res = await getCategories()
      this.categories = res.data
    },
    editCategory(row) {
      this.categoryForm = {
        id: row.id,
        name: row.name
      }
      this.showAddModal = true
    },
    async saveCategory() {
      await saveCategory(this.categoryForm)
      this.showAddModal = false
      this.loadCategories()
      this.$message.success('保存成功')
    },
    async deleteCategory(id) {
      if (confirm('确定要删除这个分类吗？')) {
        await deleteCategory(id)
        this.loadCategories()
        this.$message.success('删除成功')
      }
    }
  }
}
</script>

<style scoped>
.category-list {
  padding: 20px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
